import React from 'react'
import { connect } from 'react-redux'

import { Slider, Select, Switch, Button, Form, message } from 'antd';
import { Icon, CrownIcon, RefundIcon, CarIcon, ClockIcon } from '../core/icons'

import './UnlockPremium.css'

const UnlockPremium = ({ goToPremium, cancel }) =>
  <div className="UnlockPremium">
    <div className="features">
      <h1><CrownIcon width={40} height={40}/> Everlance Premium</h1>
      <ul>
        <li>
          <h2>Unlimited<br />Trip Detection</h2>
          Automatically tracks your miles
        </li>
        <li>
          <h2>Bank / Card<br />Integration</h2>
          Sync your expenses & revenue
        </li>
      </ul>
      <ul className="bottom-features">
        <li>
          <h2>Advanced<br />Reporting</h2>
          PDFs, filters & detailed summaries
        </li>
        <li>
          <h2>Work<br />Hours</h2>
          Set work hours to auto-classify trips
        </li>
      </ul>
    </div>

    <div className="why-premium">
      <h1>Why Premium?</h1>
      <p>
        <CarIcon width={35} height={35}/> <div>Pays for itself after 1 big trip per month</div>
      </p>
      <p>
        <ClockIcon width={35} height={35}/> <div>Save hours of your valuable time</div>
      </p>
      <p>
        <RefundIcon width={35} height={35}/> <div>100% of the cost is tax deductible</div>
      </p>
    </div>

    <div className="actions">
      <Button onClick={goToPremium} type="primary">Choose Your Plan</Button>

    </div>
  </div>

export default UnlockPremium



// WEBPACK FOOTER //
// ./src/modal/UnlockPremium.js